export default __webpack_public_path__ + "static/media/id-card.37f95f10.svg";